"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatErrorCodes = void 0;
var ChatErrorCodes;
(function (ChatErrorCodes) {
    ChatErrorCodes[ChatErrorCodes["BRINGG_USERS_NOT_FOUND"] = 100] = "BRINGG_USERS_NOT_FOUND";
    ChatErrorCodes[ChatErrorCodes["FAILED_TO_CREATE_CHAT_USER"] = 101] = "FAILED_TO_CREATE_CHAT_USER";
    ChatErrorCodes[ChatErrorCodes["FAILED_TO_CREATE_SENDBIRD_USER"] = 102] = "FAILED_TO_CREATE_SENDBIRD_USER";
    ChatErrorCodes[ChatErrorCodes["BRINGG_USER_NOT_FOUND"] = 103] = "BRINGG_USER_NOT_FOUND";
    ChatErrorCodes[ChatErrorCodes["CHAT_MERCHANT_APP_NOT_FOUND"] = 104] = "CHAT_MERCHANT_APP_NOT_FOUND";
    ChatErrorCodes[ChatErrorCodes["CHAT_MERCHANT_APP_ALREADY_EXIST"] = 105] = "CHAT_MERCHANT_APP_ALREADY_EXIST";
    ChatErrorCodes[ChatErrorCodes["CHAT_MERCHANT_APP_IS_NOT_CREATED_YET"] = 106] = "CHAT_MERCHANT_APP_IS_NOT_CREATED_YET";
    ChatErrorCodes[ChatErrorCodes["MERCHANT_CONFIGURATION_NOT_FOUND"] = 107] = "MERCHANT_CONFIGURATION_NOT_FOUND";
    ChatErrorCodes[ChatErrorCodes["MAX_SENDBIRD_APPS_LIMIT_EXCEEDED"] = 108] = "MAX_SENDBIRD_APPS_LIMIT_EXCEEDED";
    ChatErrorCodes[ChatErrorCodes["UNKNOWN_SENDBIRD_ERROR"] = 109] = "UNKNOWN_SENDBIRD_ERROR";
    ChatErrorCodes[ChatErrorCodes["SENDBIRD_REQUESTS_RATE_LIMIT_EXCEEDED"] = 110] = "SENDBIRD_REQUESTS_RATE_LIMIT_EXCEEDED";
    ChatErrorCodes[ChatErrorCodes["MERCHANT_NOT_FOUND"] = 111] = "MERCHANT_NOT_FOUND";
    ChatErrorCodes[ChatErrorCodes["NO_MERCHANT_PRIVILEGE"] = 112] = "NO_MERCHANT_PRIVILEGE";
    ChatErrorCodes[ChatErrorCodes["NO_USER_PRIVILEGE"] = 113] = "NO_USER_PRIVILEGE";
})(ChatErrorCodes || (exports.ChatErrorCodes = ChatErrorCodes = {}));
//# sourceMappingURL=error_codes.js.map